module.exports = __webpack_public_path__ + "static/media/Moon_rocket.0dd34dc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Moon_rocket.jpg
// module id = 318
// module chunks = 0